import gql from 'graphql-tag'

export const SINGLE_CASE_STUDY_BY_SLUG = gql`
query GetCaseStudyBySlug($slug: String!) {
  caseStudies(filters: { slug: { eq: $slug } }) {
    data {
      id
      attributes {
        Title
        caption
        slug
        Logo {
          data {
            attributes {
              url
              alternativeText
            }
          }
        }
        FeaturedImage {
          data {
            attributes {
              url
              alternativeText
            }
          }
        }
        SingleImage {
          data {
            attributes {
              url
              alternativeText
            }
          }
        }
        HireUs {
          Intro {
            Title
            Description
            Caption
          }
          Button {
            href
            label
            isExternal
          }
        }
        flexContent {
          ... on ComponentContentContentIntro {
            introTitle: Title  
            Description 
          }
          ... on ComponentContentQuote {
            name
            title
            organisation
            image {
              data {
                attributes {
                  url
                  alternativeText
                }
              }
            }
          }
          ... on ComponentContentVideo {
            image {
              data {
                attributes {
                  url
                  alternativeText
                }
              }
            }
            videoLink
          }
          ... on ComponentContentLargeFact {
            caption
            fact
          }
          ... on ComponentContentGridImages {
            images {
              data {
                attributes {
                  url
                  alternativeText
                }
              }
            }
          }
          ... on ComponentContentTwoColumns {
            twoColumnsTitle: Title
            Content
          }
          ... on ComponentContentWebsiteCta {
            ctaTitle: Title
            Link
            buttonLabel
          }
          ... on ComponentContentQuoteSmall {
            image {
              data {
                attributes {
                  url
                  alternativeText
                }
              }
            }
            title
            name
            organisation
          }
          ... on ComponentContentSingleImage {
            singleImage {
              data {
                attributes {
                  url
                  alternativeText
                }
              }
            }
            fullWidth
          }
          ... on ComponentContentImageCarousel {
            images {
              data {
                attributes {
                  url
                  alternativeText
                }
              }
            }
          }
          ... on ComponentContentTwoColumnsText {
            text1
            text2
          }
          ... on ComponentContentTwoColumnsFacts {
            twoColumnsFactsTitle: Title
            blocks {
              Number
              Description
            }
          }
          ... on ComponentContentThreeColumnsFacts {
            threeColumnsFactsTitle: Title
            blocks {
              Number
              Description
            }
          }
        }
        seo {
          metaTitle
          metaDescription
          metaImage {
            data {
              attributes {
                url
                alternativeText
              }
            }
          }
          metaSocial {
            socialNetwork
            title
            description
            image {
              data {
                attributes {
                  url
                  alternativeText
                }
              }
            }
          }
        }
      }
    }
  }
}
`
